module.exports = __webpack_public_path__ + "assets/img/warrior-name-1359db11.png";